<template>
  <div>
    <general-top-bar :title="$t('reports.charismaReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="loc in locations" :key="loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>

          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('general.orderId')}}</label>
            <input 
              type="number"
              min="0"
              name="price"
              placeholder="3823231"
              v-model="selectedOrderId"
              class="form-control">
          </div>

          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('charisma.categoryAdministration')}}</label>
            <v-select
              v-model="selectedAdministration"
              :options="administrations"
              label="name"
              name="administration-select"
              :placeholder="$t('general.select')">
            </v-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('catalogProd.status')}}</label>
            <v-select
              v-model="selectedType"
              :options="types"
              label="name"
              name="type-select"
              :placeholder="$t('catalogProd.status')">
            </v-select>
          </div>
          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('charisma.documentType')}}</label>
            <v-select
              v-model="selectedDocument"
              :options="documents"
              label="name"
              name="document-select"
              :placeholder="$t('charisma.documentType')">
            </v-select>
          </div>
          <div class="mb-3 w-100 mar-bt-15">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label text-start w-100">{{$t('invoice.series')}}</label>
                <input 
                  type="text"
                  name="series"
                  placeholder=""
                  v-model="selectedSeries"
                  class="form-control">
              </div>
              <div class="col-md-6">
                <label class="form-label text-start w-100">{{$t('invoice.number')}}</label>
                <input 
                  type="number"
                  min="0"
                  name="number"
                  placeholder=""
                  v-model="selectedNumber"
                  class="form-control">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <p class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </p>
          <div class="pull-left search-button-reports">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <div :title="$t('charisma.sendAll')" class="btn btn-icon btn-xls-slim" @click="sendAll()">{{$t('charisma.sendAll') }}</div>
          </div>
        </p>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:00</b></p>
      </div>

      <div class="col-md-12" style="margin-top: 15px;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          class="report-sales"
          key="sales-table"
          style="width: 100%"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="56" prop="id" :label="$t('reports.id')"/>
            <el-table-column class-name="centered-cell" :min-width="100" prop="order_id" :label="$t('general.orderId')"/>
            <el-table-column class-name="centered-cell" :min-width="80" prop="name" :label="$t('reports.location')"/>
            <el-table-column class-name="centered-cell" :min-width="80" prop="administration_name" :label="$t('charisma.categoryAdministration')"/>
            <el-table-column class-name="centered-cell" :min-width="80" prop="totals_grandtotal" :label="$t('reports.orderTotal')">
              <template slot-scope="props">
                {{formatMoneyAmount(Number(props.row.totals_grandtotal || 0))}}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="charisma_status" :label="$t('charisma.bill')">
              <template slot-scope="props">
                {{ $t('charisma.charisma' + props.row.charisma_status) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="80" prop="charisma_invoice_status" :label="$t('charisma.invoice')">
              <template slot-scope="props">
                {{ $t('charisma.charisma' + props.row.charisma_invoice_status) }}
              </template>
            </el-table-column>

            <el-table-column class-name="centered-cell" :min-width="80" prop="series" :label="$t('invoice.series')">
              <template slot-scope="props">
                {{ props.row.series ? props.row.series : '-' }}
              </template>
            </el-table-column>

            <el-table-column class-name="centered-cell" :min-width="80" prop="number" :label="$t('invoice.number')">
              <template slot-scope="props">
                 {{ props.row.number ? props.row.number : '-' }}
              </template>
            </el-table-column>

            <el-table-column class-name="centered-cell" :min-width="80" prop="created_at" :label="$t('charisma.createDate')">
              <template slot-scope="props">
                {{ (formatToCompanyTimezone(props.row.created_at, timezone)) }}
              </template>
            </el-table-column>

            <el-table-column class-name="centered-cell" :min-width="80" prop="updated_at" :label="$t('charisma.updateDate')">
              <template slot-scope="props">
                {{ (formatToCompanyTimezone(props.row.updated_at, timezone)) }}
              </template>
            </el-table-column>

            <el-table-column
              :min-width="110"
              width="110"
              prop="actions"
              class-name="centered-cell charisma-actions-column"
              :label="$t('general.actions')">
              <template slot-scope="props">
                <div class="display-flex" style="align-items: center; margin: auto">
                  <!-- <a
                    class="btn btn-icon btn-purple mar-rt-10" 
                    :title="$t('marketingCampaigns.send')"
                    :disabled="props.row.charisma_status !== 1 && props.row.charisma_invoice_status !== 1"
                    @click="sendOrder(props.$index, props.row)">
                    <i class="ti-email"></i>
                  </a> -->
                  <a
                    class="btn btn-icon btn-purple mar-rt-10" 
                    :title="$t('marketingCampaigns.open')" 
                    @click="goToItems(props.row)">
                    <i class="ti-angle-right"></i>
                  </a>
                </div>
              </template>
            </el-table-column>

        </data-tables-server>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import SearchableMultiSelect from 'src/components/UIComponents/Inputs/SearchableMultiSelect.vue'

export default {
  components: {
    GeneralTopBar,
    SearchableMultiSelect,
    [DatePicker.name]: DatePicker
  },
  props: {
    isCharismaReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isCharismaReport: {
      immediate: true,
      handler (val) {
        // if (val) {
        this.applyRouteFilters()
        this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 })
        this.verifyUserLocations()
        this.verifyUserMethods()
        this.initAdministrations()
        // }
      }
    }
  },
  created () {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      types: [
        {id: null, name: this.$t('general.all')},
        {id: 1, name: this.$t('charisma.charisma1')},
        {id: 20, name: this.$t('charisma.charisma2')},
        {id: 3, name: this.$t('charisma.charisma3')},
        {id: 4, name: this.$t('charisma.charisma4')}
      ],
      selectedType: null,
      documents: [
        {id: null, name: this.$t('general.all')},
        {id: 'bill', name: this.$t('charisma.bill')},
        {id: 'invoice', name: this.$t('charisma.invoice')}
      ],
      selectedDocument: null,
      selectedSeries: null,
      selectedNumber: null,
      administrations: [],
      selectedAdministration: null,
      selectedAdministrationIdFromRoute: null,
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().subtract(1, 'day').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      noData: false,
      selectedOrderId: null,
      timezone: null
    }
  },
  methods: {
    handleRefresh () {
      this.getOrders({
        page: this.paginationProps.currentPage || 1,
        pageSize: this.paginationProps.pageSize || 20
      })
    },
    applyRouteFilters () {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      if (q.from && q.to) {
        this.orders.valid = [q.from, q.to]
      }
      if (q.timeFrom) this.valid_from = q.timeFrom
      if (q.timeTo) this.valid_to = q.timeTo
      if (q.location) this.orders.location = q.location
      if (q.orderIdFilter) this.selectedOrderId = q.orderIdFilter
      if (q.type !== undefined) {
        const typeId = Number(q.type)
        this.selectedType = this.types.find(t => t && t.id === typeId) || null
      }
      if (q.document !== undefined) {
        this.selectedDocument = this.documents.find(d => d && d.id === q.document) || null
      }
      if (q.series !== undefined) {
        this.selectedSeries = q.series
      }
      if (q.number !== undefined) {
        this.selectedNumber = q.number ? Number(q.number) : null
      }
      if (q.admin !== undefined) {
        const adminId = Number(q.admin)
        // Store the ID to resolve later when administrations are loaded
        this.selectedAdministrationIdFromRoute = adminId
        // Try to resolve immediately if administrations are already loaded
        if (this.administrations && this.administrations.length > 0) {
          this.selectedAdministration = this.administrations.find(a => a && a.id === adminId) || null
          this.selectedAdministrationIdFromRoute = null
        }
      }
      if (q.page) this.paginationProps.currentPage = isNaN(q.page) ? q.page : Number(q.page)
      if (q.perPage) this.paginationProps.pageSize = isNaN(q.perPage) ? q.perPage : Number(q.perPage)
    },
    initAdministrations () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations']
        if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
          this.selectedAdministration = this.administrations.find(a => a && a.id === Number(this.selectedAdministrationIdFromRoute)) || null
          this.selectedAdministrationIdFromRoute = null
        }
        return
      }
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/administration', 'GET', data, (response) => {
        if (response && response.status && Array.isArray(response.data)) {
          this.administrations = response.data
          sessionData['administrations'] = response.data
          this.$session.set('selectedCompanyData', sessionData)
          if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
            this.selectedAdministration = this.administrations.find(a => a && a.id === Number(this.selectedAdministrationIdFromRoute)) || null
            this.selectedAdministrationIdFromRoute = null
          }
        } else {
          this.administrations = []
        }
      })
    },
    goToItems (row) {
      const orderId = row.order_id || row.id
      if (!orderId) { return }
      const page = this.paginationProps.currentPage || 1
      const perPage = this.paginationProps.pageSize || 20
      const query = {
        tab: 'charisma',
        page,
        perPage,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      }
      if (this.orders.location) query.location = this.orders.location
      if (this.selectedOrderId) query.orderIdFilter = this.selectedOrderId
      if (this.selectedType) query.type = this.selectedType.id ? this.selectedType.id : this.selectedType
      if (this.selectedDocument) query.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
      if (this.selectedSeries) query.series = this.selectedSeries
      if (this.selectedNumber) query.number = this.selectedNumber
      if (this.selectedAdministration) query.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
      this.$router.push({
        name: 'Charisma Items',
        params: { orderId: String(orderId) },
        query
      })
    },
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        const pageSize = query.pageSize || this.paginationProps.pageSize || 20
        const page = query.page || this.paginationProps.currentPage || 1
        const syncQuery = Object.assign({}, this.$route.query, {
          tab: 'charisma',
          page,
          perPage: pageSize,
          from: this.orders.valid[0],
          to: this.orders.valid[1],
          timeFrom: this.valid_from,
          timeTo: this.valid_to
        })
        if (this.orders.location) syncQuery.location = this.orders.location
        if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId
        if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType
        if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
        if (this.selectedSeries) syncQuery.series = this.selectedSeries
        if (this.selectedNumber) syncQuery.number = this.selectedNumber
        if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
        this.$router.replace({ path: '/reports', query: syncQuery })
        this.getOrders(query)
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isCharismaReport) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00'
      let toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00'

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId
      }

      if (this.selectedType) {
        data.status = this.selectedType.id
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id
      }

      this.loading = true
      const pageSize = (query && query.pageSize) ? query.pageSize : (this.paginationProps.pageSize || 20)
      const page = (query && query.page) ? query.page : (this.paginationProps.currentPage || 1)

      this.apiRequest('/reports/v2/charisma' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data.length) {
            this.ordersTableData.data = response.data.table_data
            this.ordersTableData.total = response.pagination.total
            this.paginationProps.currentPage = response.pagination.page
            this.paginationProps.pageSize = response.pagination.perPage
          } else {
            this.ordersTableData.data = []
            this.ordersTableData.total = 0
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = 20
          }

          this.noData = false
        } else {
          this.discounts = []
          this.noData = true

          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    sendAll () {
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: this.orders.valid[0],
        to_date: this.orders.valid[1]
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId
      }

      if (this.selectedType) {
        data.status = this.selectedType.id
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id
      }

      this.loading = true

      this.apiRequest('/reports/v2/charisma/mark-orders', 'POST', data, response => {
        if (response.status) {
          swal(
            '',
            this.$t('charisma.sendAllMessage'),
            'success'
          )
        } else {
          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    updateData () {
      const syncQuery = Object.assign({}, this.$route.query, {
        tab: 'charisma',
        page: this.paginationProps.currentPage || 1,
        perPage: this.paginationProps.pageSize || 20,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      })
      if (this.orders.location) syncQuery.location = this.orders.location
      if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId
      if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType
      if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
      if (this.selectedSeries) syncQuery.series = this.selectedSeries
      if (this.selectedNumber) syncQuery.number = this.selectedNumber
      if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
      this.$router.replace({ path: '/reports', query: syncQuery })
      this.getOrders({ page: syncQuery.page, pageSize: syncQuery.perPage })
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row slim {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  /* .ct-label.ct-horizontal {
    white-space: pre-line;
    text-anchor: middle;
    font-size: 12px;
  } */
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  /* .ct-chart {
    overflow: visible !important;
  } */

  .ct-chart {
    padding-top: 20px; /* or more */
    overflow: visible !important;
  }

  .slim {
    margin-bottom: 10px !important;
  }

  .report-sales .charisma-actions-column .cell {
    padding-left: 8px;
    padding-right: 12px;
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/CharismaReport.vue